import { formatAmount } from './money';

/** The count line of a catalog: "1 car", "14 cars", "0 cars". The number is pinned to en-US like every other. */
export const pluralCars = (total: number): string =>
  `${formatAmount(total)} ${total === 1 ? 'car' : 'cars'}`;
